<template>
  <div class="wrapper">Something went wrong. Reason: {{ props.reason }}</div>
</template>

<script lang="ts" setup>
const props = defineProps<{ reason: unknown }>();
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  min-height: 350px;
}
</style>
